import React from 'react'
import { graphql } from 'gatsby'
import Layout from '../components/layout'
import Contact from '../components/contact'
import { Container, Row, Col } from 'react-bootstrap'
import { Link } from 'gatsby'
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLongArrowAltRight } from '@fortawesome/free-solid-svg-icons'
import _ from 'lodash'
import ColoredBanner from '../components/ColoredBanner'
config.autoAddCss = false

const Infothek = ({ data, location }) => {
  return (
    <Layout location={location} noEnglish noSEO={true}>
      <Container>
        <ColoredBanner backgroundColor="green" title="Infothek.">
          Auch in einer kleinen Agentur gibt es immer wieder Neuigkeiten. Transparenz ist uns wichtig und daher teilen
          wir unser Wissen auch gern.
        </ColoredBanner>

        <Row className="blog">
          <Col>
            <Container>
              <Row className="mt-5">
                <Col>
                  <Row>
                    {data.news.edges.map(infothek => (
                      <Col xs="12" className=" mb-5" key={infothek.node.frontmatter.slug}>
                        <span className="small text-muted">vom {infothek.node.frontmatter.date}</span>
                        <h2>
                          <Link to={`/infothek/${_.kebabCase(infothek.node.frontmatter.slug)}/`}>
                            {infothek.node.frontmatter.title}
                          </Link>
                        </h2>
                        <p>{infothek.node.frontmatter.intro}</p>
                        <Link to={`/infothek/${_.kebabCase(infothek.node.frontmatter.slug)}/`}>
                          Beitrag lesen <FontAwesomeIcon icon={faLongArrowAltRight} />
                        </Link>
                      </Col>
                    ))}
                  </Row>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      </Container>
      <Contact />
    </Layout>
  )
}

export default Infothek

export const query = graphql`
  {
    news: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/files/infothek/i" } }
      sort: { frontmatter: { date: DESC } }
    ) {
      edges {
        node {
          frontmatter {
            slug
            title
            date(locale: "de", formatString: "MMMM Y")
            intro
          }
        }
      }
    }
  }
`
